import { create } from 'zustand'
import { Notificacao } from '@/types/notificacao'

export interface NotificacaoStore {
  notificacoes: Notificacao[]
  naoLidas: number
  total: number
  isLoading: boolean

  setNotificacoes: (notificacoes: Notificacao[]) => void
  adicionarNotificacao: (notificacao: Notificacao) => void
  marcarLida: (id: string) => void
  setNaoLidas: (count: number) => void
  setTotal: (count: number) => void
  setLoading: (loading: boolean) => void
  limpar: () => void
}

export const notificacaoStore = create<NotificacaoStore>((set) => ({
  notificacoes: [],
  naoLidas: 0,
  total: 0,
  isLoading: false,

  setNotificacoes: (notificacoes: Notificacao[]) => {
    set({ notificacoes })
  },

  adicionarNotificacao: (notificacao: Notificacao) => {
    set((state) => ({
      notificacoes: [notificacao, ...state.notificacoes],
    }))
  },

  marcarLida: (id: string) => {
    set((state) => ({
      notificacoes: state.notificacoes.map((n) =>
        n.id === id ? { ...n, lida: true } : n
      ),
    }))
  },

  setNaoLidas: (count: number) => {
    set({ naoLidas: count })
  },

  setTotal: (count: number) => {
    set({ total: count })
  },

  setLoading: (loading: boolean) => {
    set({ isLoading: loading })
  },

  limpar: () => {
    set({
      notificacoes: [],
      naoLidas: 0,
      total: 0,
      isLoading: false,
    })
  },
}))
